import React, { useState } from 'react';
import { Circle, Layer, Line, Rect } from 'react-konva';

const VisionBarrierLayer = ({ bounds, walls = [], editing = false, selectedWallId = null, onSelect, onCreate, onEndpointMove }) => {
  const [start, setStart] = useState(null);
  const [pointer, setPointer] = useState(null);
  const readPoint = (event) => event?.target?.getLayer?.()?.getRelativePointerPosition?.()
    || event?.target?.getStage?.()?.getPointerPosition?.()
    || null;
  const click = (event) => {
    if (!editing) return;
    event.cancelBubble = true;
    const point = readPoint(event);
    if (!point) return;
    if (!start) setStart(point);
    else {
      onCreate?.({ start, end: point });
      setStart(null);
      setPointer(null);
    }
  };
  return (
    <Layer listening={editing}>
      {editing && <Rect x={bounds.x} y={bounds.y} width={bounds.width} height={bounds.height} fill="rgba(0,0,0,0.001)" onClick={click} onTap={click} onMouseMove={(event) => setPointer(readPoint(event))} />}
      {walls.map((wall) => {
        const selected = wall.wallId === selectedWallId;
        return (
          <React.Fragment key={wall.wallId}>
            <Line
              points={[wall.start.x, wall.start.y, wall.end.x, wall.end.y]}
              stroke={selected ? '#ffe29a' : (wall.blocksVision ? '#e08c74' : '#79a6d8')}
              strokeWidth={selected ? 4 : 3}
              dash={wall.visibility === 'gm_only' ? [8, 5] : undefined}
              hitStrokeWidth={14}
              onClick={(event) => { event.cancelBubble = true; onSelect?.(wall.wallId); }}
              onTap={(event) => { event.cancelBubble = true; onSelect?.(wall.wallId); }}
            />
            {editing && selected && !wall.locked && ['start', 'end'].map((endpoint) => (
              <Circle
                key={endpoint}
                x={wall[endpoint].x}
                y={wall[endpoint].y}
                radius={7}
                fill="#ffe29a"
                stroke="#171b24"
                strokeWidth={2}
                draggable
                onDragEnd={(event) => onEndpointMove?.(wall, endpoint, { x: event.target.x(), y: event.target.y() })}
              />
            ))}
          </React.Fragment>
        );
      })}
      {editing && start && pointer && <Line points={[start.x, start.y, pointer.x, pointer.y]} stroke="#ffe29a" strokeWidth={3} dash={[6, 4]} listening={false} />}
    </Layer>
  );
};

export default VisionBarrierLayer;
